import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const InsuredOccupation = (props) => {
  return (
    <FormGroup controlId="insuredOccupation">
      <Col componentClass={ControlLabel} sm={5}>
        The Insured&apos;s Occupation
      </Col>
      <Col sm={7}>
        <FormControl
          type="text"
          value={props.insuredOccupation}
          onChange={props.handleChangeInsuredOccupation} autoComplete="off" />
      </Col>
    </FormGroup>
  )
}

InsuredOccupation.propTypes = {
  insuredOccupation: PropTypes.string,
  handleChangeInsuredOccupation: PropTypes.func
};

export default InsuredOccupation;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/insuredOccupation/InsuredOccupation.js